import { File } from "../classes/File.js";
export const userHydration = {
    keyMapping: {
        _id: "id",
        display_name: "displayName",
        // external_avatar_url and can_create_servers are Whitemane extensions
        // not in the stoat-api schema
        external_avatar_url: "externalAvatarURL",
        can_create_servers: "canCreateServers",
    },
    functions: {
        id: (user) => user._id,
        username: (user) => user.username,
        discriminator: (user) => user.discriminator,
        displayName: (user) => user.display_name,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        externalAvatarURL: (user) => user.external_avatar_url ?? undefined,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        canCreateServers: (user) => user.can_create_servers ?? undefined,
        relationship: (user) => user.relationship,
        relations: () => null,
        online: (user) => user.online,
        privileged: (user) => user.privileged,
        badges: (user) => user.badges,
        flags: (user) => user.flags,
        avatar: (user, ctx) => new File(ctx, user.avatar),
        status: (user) => user.status,
        bot: (user) => user.bot,
    },
    initialHydration: () => ({
        relationship: "None",
    }),
};
/**
 * Badges available to users
 */
export var UserBadges;
(function (UserBadges) {
    UserBadges[UserBadges["Developer"] = 1] = "Developer";
    UserBadges[UserBadges["Translator"] = 2] = "Translator";
    UserBadges[UserBadges["Supporter"] = 4] = "Supporter";
    UserBadges[UserBadges["ResponsibleDisclosure"] = 8] = "ResponsibleDisclosure";
    UserBadges[UserBadges["Founder"] = 16] = "Founder";
    UserBadges[UserBadges["PlatformModeration"] = 32] = "PlatformModeration";
    UserBadges[UserBadges["ActiveSupporter"] = 64] = "ActiveSupporter";
    UserBadges[UserBadges["Paw"] = 128] = "Paw";
    UserBadges[UserBadges["EarlyAdopter"] = 256] = "EarlyAdopter";
    UserBadges[UserBadges["ReservedRelevantJokeBadge1"] = 512] = "ReservedRelevantJokeBadge1";
    UserBadges[UserBadges["ReservedRelevantJokeBadge2"] = 1024] = "ReservedRelevantJokeBadge2";
})(UserBadges || (UserBadges = {}));
/**
 * Flags attributed to users
 */
export var UserFlags;
(function (UserFlags) {
    UserFlags[UserFlags["Suspended"] = 1] = "Suspended";
    UserFlags[UserFlags["Deleted"] = 2] = "Deleted";
    UserFlags[UserFlags["Banned"] = 4] = "Banned";
})(UserFlags || (UserFlags = {}));
